<!--
 * @Author: 徐艳龙 w17630400757@163.com
 * @Date: 2022-05-07 08:40:45
 * @LastEditors: 徐艳龙 w17630400757@163.com
 * @LastEditTime: 2022-06-02 17:29:51
 * @FilePath: \Home\Transfor-website\src\views\pc\Index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <div class="homeBottom">
      <div class="homeBottom-W">
        <div class="hei"></div>
        <div class="bai"></div>
        <div>
          <span></span>
          <span>Join us</span>
        </div>
        <div>
          <!-- <p>
            A thriving global <span> ecosystem </span
            ><span>is the vision of Transformers.</span>
          </p> -->

          <p>
            Attracting countless Web3.0 entrepreneurs to change the world With a
            strong <span> gravitational force </span> like the sun.
          </p>
          <img src="@/assets/pc/Home/att.png" />
        </div>
        <div>
          <ul>
            <li>
              <div class="Run">
                <a
                  :href="`${baseUrl}/doc/run-node#as-an-rpc-node`"
                  target="_blank"
                >
                  <p>Running an RPC node</p>
                  <p>
                    Build data sources for visual applications and provide a
                    user experience.
                  </p>
                  <span class="Img1 Img3"></span
                ></a>
              </div>
              <div class="Run">
                <a
                   :href="`${baseUrl}/doc/node/delegators`"
                  target="_blank"
                >
                  <p>Become the client to participate in the share dividends</p>
                  <p>
                    Select a stable validator to improve their security and get
                    your stake.
                  </p>
                  <span class="Img1 Img3"></span
                ></a>
              </div>
            </li>
            <li>
              <div class="Run">
                <a :href="`${baseUrl}/doc/run-node`" target="_blank">
                  <p>Run the validator</p>
                  <p>
                    Establish scattered validator nodes, maintain network
                    security, and obtain the commission delivery of inflation
                    share
                  </p>

                  <span class="Img2 Img3"></span
                ></a>
              </div>
              <div class="Run">
                <p>Join Transformers collective</p>
                <p>
                  Join the development of Transformers, and contribute your
                  strength to get the TTOS rewards.
                </p>
                <span class="Img2 Img3" @click="Masg"></span>
              </div>
            </li>
          </ul>
        </div>
        <div class="qipao">
          Decentralization, autonomy, equality, and freedom are the development
          ideas of Transformers.
        </div>
        <div class="qipao2"></div>
      </div>
    </div>
    <!-- 饼状图开始 -->
    <!-- <div class="homeBottomChart">
      <div class="homeBottom-W">
        <div class="Infortitle">
          <div class="Infort1">Project Fundraising Informatian</div>
          <div class="Infort2">
            The total circulation of TFSC is<span> 70 million</span>, and the
            distribution proportion is as follows
          </div>
        </div>
        <div class="Inforcont">
          <div class="contents">
            <div class="cons1">
              This fundraising is a seed round. The specific information is as
              follows. Interested friends are welcome to participate!
            </div>
            <div class="cons2">
              Fund raising limit: 10% ( including 6% seed round and 4%
              ecological NFT); Pricing: 0.7U/TFSC
            </div>
            <div class="cons3">
              Release ratio: 15% will be released quarterly after TFSC assets
              are launched online
               [<span @click="tankuang"
                >check the release situation</span
              >]
            </div>
            <div class="cons4">Email: invest@tfscio</div>
            <div class="cons5">
              (Note: This email can be used for seed round related information
              consultation.Confirm the amount of investment; Confirm the airdrop
              address after investment; Confirm the identity of the investment
              institution;Used to accept documents and confirm relevant emails)
            </div>
          </div>
          <div class="charts" ref="chart"></div>
         
          <div class="To_List" :style="{ height: H }" v-show="flag">
            <div class="To_List-all">
              <div class="To_List_top">
                <span>TFSC asset release list</span>
                <span
                  ><img src="@/assets/pc/Home/gb.png" alt="" @click="none"
                /></span>
              </div>
              <div class="To_List_ul">
                <div class="To_listt">
                  <div class="To_listtit">Release time</div>
                  <div class="To_listtcon">Amount</div>
                </div>
                <ul>
                  <li>
                    <span class="notranslate">2023-01-14</span>
                    <span class="notranslate">2000TFSC</span>
                  </li>
                  <li>
                    <span class="notranslate">2023-01-14</span>
                    <span class="notranslate">2000TFSC</span>
                  </li>
                  <li>
                    <span class="notranslate">2023-01-14</span>
                    <span class="notranslate">2000TFSC</span>
                  </li>
                  <li>
                    <span class="notranslate">2023-01-14</span>
                    <span class="notranslate">2000TFSC</span>
                  </li>
                  <li>
                    <span class="notranslate">2023-01-14</span>
                    <span class="notranslate">2000TFSC</span>
                  </li>
                  <li>
                    <span class="notranslate">2023-01-14</span>
                    <span class="notranslate">2000TFSC</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
         
        </div>
      </div>
    </div> -->
    <!-- 流量大使开始 -->
    <div class="Ambassador">
      <div class="Ambassador_w">
        <div class="Amba_tit">
          <div class="line"></div>
          <div class="line_tit">Welcome to apply</div>
        </div>
        <div class="Amba_con">
          Transformers <span>Ambassador</span> Application
        </div>
        <div class="Amba_foot">
          <div class="Amba_footl">
            We look forward to the registration of community friends in
            different languages and cities around the world. Transformers
            belongs to the world and belongs to everyone！
          </div>
          <router-link to="/Index/Ambassador">
            <div class="Amba_footr">Apply now</div>
          </router-link>
        </div>
      </div>
    </div>
    <!-- 流量大使结束 -->
    <!-- 饼状图结束 -->
    <!-- NFT开始 -->
    <div class="homeBottomNft">
      <div class="homeBottom-W">
        <div class="homeNfttile">
          <div class="homeNl">
            <div class="homeNlt">
              <span></span>
              <div>Our Team</div>
            </div>
            <div class="homeNlc">
              Core contributors of Transformers
              <!-- The <span>team</span> behind the blockchain -->
            </div>
          </div>
          <div class="homeNr">
            <img src="@/assets/pc/Home/jiant.png" />
          </div>
        </div>
        <div class="homeNftcont">
          <ul>
            <li>
              <img
                v-image-preview
                src="https://fastcdn.uscloudmedia.com/transformers/osite/1.png"
              />
              <span>Aleksandr lvanov</span>
              <span>Technical Initiator</span>
            </li>
            <li>
              <img
                v-image-preview
                src="https://fastcdn.uscloudmedia.com/transformers/osite/2.png"
              />
              <span>Hans Müller</span>
              <span>Architect</span>
            </li>
            <li>
              <img
                v-image-preview
                src="https://fastcdn.uscloudmedia.com/transformers/osite/3.png"
              />
              <span>Eli Cohen</span>
              <span>Core Developer</span>
            </li>
            <li>
              <img
                v-image-preview
                src="https://fastcdn.uscloudmedia.com/transformers/osite/4.png"
              />
              <span>Emily Li</span>
              <span>Core Developer</span>
            </li>
            <li>
              <img
                v-image-preview
                src="https://fastcdn.uscloudmedia.com/transformers/osite/5.png"
              />
              <span>Cole Anderson</span>
              <span>Core Developer</span>
            </li>
            <li>
              <img
                v-image-preview
                src="https://fastcdn.uscloudmedia.com/transformers/osite/6.png"
              />
              <span>James Smith</span>
              <span>Core Developer</span>
            </li>
            <li>
              <img
                v-image-preview
                src="https://fastcdn.uscloudmedia.com/transformers/osite/7.png"
              />
              <span>Sergei Petrov</span>
              <span>Core Developer</span>
            </li>
          </ul>
          <div class="xiana"></div>
        </div>
      </div>
    </div>
    <!-- NFT结束 -->
    <div class="homeBottom2">
      <div class="xianl">
        <div class="xian"></div>
      </div>

      <div class="homeBottom-W">
        <!-- <p class="Logo_Text">Technical route</p> -->
        <p class="Logo_Text">TFSC RoadMap</p>
        <ul class="clearfix">
          <li>
            <div>
              <span style="margin-top: 40px">2024-Q2</span>

              <span><img src="../../../assets/pc/Home/Home01.png" /></span>
              <span class="rightss">
                <p>Alpha test net launch;</p>
                <p>Main net launch;</p>
                <p>
                  Enhancement of developer documentation (API/SDK/development
                  framework);
                </p>
                <p>Open-sourcing of Transformer code;</p>
                <p>Cross-chain protocol;</p>
                <!-- <p>Expanding global ambassadors</p> -->
              </span>
            </div>
            <div class="yinying"></div>
            <p class="JianT">
              <img src="../../../assets/pc/Home/Home010.png" />
            </p>
          </li>
          <li>
            <div style="margin-top: 10px">
              <span>
                <p>Developer incentive program;</p>
                <p>
                  Introduction of support for BTC ecosystem technology stack;
                </p>
                <p>Hackathon;</p>
                <!-- <p>Initiate DAO donation round</p> -->
              </span>

              <span><img src="../../../assets/pc/Home/Home02.png" /></span>
              <span style="margin-top: 32px">
                <p>2024-Q3</p>
              </span>
            </div>
            <div class="yinying"></div>
            <p class="JianT">
              <img src="../../../assets/pc/Home/Home010.png" />
            </p>
          </li>
          <li>
            <div style="margin-top: 30px">
              <span style="margin-top: 10px">2024-Q4</span>

              <span><img src="../../../assets/pc/Home/Home03.png" /></span>
              <span class="rightss1" style="padding-top: 10px">
                <p>Interoperability of multi-chain assets;</p>
                <p>
                  Launch of decentralized governance protocol for ecosystem
                  fund;
                </p>
                <!-- <p>TOP CEX +1~3</p> -->
                <!-- <p>
                  Transforme code open-source
                </p> -->
              </span>
            </div>
            <div class="yinying"></div>
            <!-- <p class="JianT">
              <img src="../../../assets/pc/Home/Home010.png" />
            </p> -->
          </li>
          <!-- <li>
            <div style="margin-top: 24px;margin-right: 12px;">
              <span>
                <p>In line with the development direction of Web3, </p>
                <p>unveil a roadmap that aligns better with Transformers's </p>
                <p>development.</p>
              </span>

              <span><img src="../../../assets/pc/Home/Home04.png" /></span>
              <span style="margin-top: 24px">
                <p>2024-Q2</p>
              </span>
            </div>
         
          </li> -->
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { base2 } from "@/assets/server/api";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/swiper-bundle.css";
const echarts = require("echarts");
export default {
  data() {
    return {
      baseUrl: base2,
      ImgUrl: require("@/assets/pc/Home/Home6.png"),
      flag: false,
      H: "",
      W: document.body.clientWidth + "px",
      list: [
        {
          name: "2023-Q1",
          NameText: "Launch global public test",
          NameText2: "Intelligent contract test",
          NameText3: "NFT protocol test ",
          NameText4: "Completed Seed Round",
          NameText5: "Expanding global ambassadors",

          ImgUrl: require("../../../assets/pc/Home/Home01.png"),
        },
        {
          name: "Launch Cross-chain bridge deployment , ",

          NameText: "2023-Q2",

          ImgUrl: require("../../../assets/pc/Home/Home02.png"),
        },
        {
          name: "2023-Q3",
          NameText: "Completed Series A",
          NameText2: "Held the first hackathon",
          NameText3: "Expending ecological members to 50 ",
          ImgUrl: require("../../../assets/pc/Home/Home03.png"),
        },
        {
          name: "Expending ecological members to 100 Holders increased to 1 million ",
          NameText: "2023-Q4",
          ImgUrl: require("../../../assets/pc/Home/Home04.png"),
        },
      ],
      id: 2,
    };
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  computed: {
    goPage() {},
  },
  created() {
    // this.$bus.$emit("Obtain", "#twe");
  },
  mounted() {
    this.H = document.body.offsetHeight + "px";
    window.onresize = () => {
      return (() => {
        this.H = document.body.offsetHeight + "px";
      })();
    };
    // this.initCharts();
  },
  destroyed() {},
  methods: {
    Masg() {
      this.$message("Coming Soon");
    },
    //停止页面滚动
    stopMove() {
      document.body.style.overflow = "hidden ";
    },
    //开启页面滚动
    Move() {
      document.body.style.overflow = "";

      // document.body.style.paddingRight = "0px";
      // console.log("ccccc", document.body.style.overflow);
    },
    none() {
      this.flag = false;
      this.Move();
    },
    // tankuang() {
    //   this.flag = true;

    //   this.stopMove();
    // },
    initCharts() {
      this.pieChart = echarts.init(this.$refs.chart);
      let option = {
        tooltip: {
          trigger: "item",
          // formatter: function (params) {
          //   console.log(params);
          //   var relVal = params[0].name;
          //   for (var i = 0, l = params.length; i < l; i++) {
          //     relVal +=
          //       "<br/>" +
          //       params[i].marker +
          //       params[i].seriesName +
          //       " : " +
          //       params[i].value +
          //       "%";
          //   }
          //   return relVal;
          // },
          //formatter: "<br/>{b}: {c} ({d}%)",
          formatter:
            '<span style="color: #371341;font-size: 20px;font-weight: 900;margin-right:5px;">' +
            "{d}%" +
            "</span>" +
            "{b}",
        },
        legend: {
          bottom: "15%",
          left: "left",
          icon: "roundReact",
          itemGap: 50, //图例每项之间的间隔
          itemWidth: 32, //图例标记的图形宽度
          itemHeight: 16,
          textStyle: {
            fontSize: 14,
            color: "#3D3D3D",
          },
        },
        series: [
          {
            name: "Access From",
            type: "pie",

            center: ["80%", "32%"],
            radius: ["0%", "60%"],
            avoidLabelOverlap: false,
            // hoverAnimation: false ,
            // silent: true,
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: false,
                fontSize: 40,
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            data: [
              {
                value: 40,
                name: "Global Laboratory Development",
                itemStyle: { emphasis: { color: "#FEEBFF" } },
              },
              {
                value: 5,
                name: "Community Operation",
                itemStyle: { emphasis: { color: "#F4BAF4" } },
              },
              {
                value: 15,
                name: "Community Airdrop",
                itemStyle: { emphasis: { color: "#CE62DA" } },
              },
              {
                value: 30,
                name: "Ecological Development Fund",
                itemStyle: { emphasis: { color: "#A747B3" } },
              },
              {
                value: 10,
                name: "Seed Round",
                itemStyle: { emphasis: { color: "#371341" } },
              },
              // { value: 40, name: "Global Laboratory Development" },
              // { value: 5, name: "Community Operation" },
              // { value: 10, name: "Community Airdrop" },
              // { value: 30, name: "Ecological Development Fund" },
              // { value: 15, name: "Seed Round" },
            ],

            itemStyle: {
              normal: {
                borderRadius: 20,
                borderColor: "#fff",
                borderWidth: 4,
                color: function (colors) {
                  var colorList = [
                    "#FEEBFF",
                    "#F4BAF4",
                    "#CE62DA",
                    "#A747B3",
                    "#371341",
                  ];
                  return colorList[colors.dataIndex];
                },
              },
              // emphasis: {
              //   color: "#abcdef", //移入后的颜色

              // },
            },
          },
        ],
      };
      this.pieChart.setOption(option);
    },
  },
};
</script>
<style lang="less">
.homeBottom {
  width: 100%;
  background: #141414;
  .homeBottom-W {
    width: 1320px;
    margin: 0 auto;
    padding: 160px 0 137px 0;
    position: relative;
    background: #141414;
    .hei {
      width: 30px;
      height: 30px;
      background: #141414;
      position: absolute;
      top: -30px;
      left: 0;
    }
    .bai {
      width: 30px;
      height: 68px;
      background: #ffffff;
      position: absolute;
      top: 0;
      left: 0;
    }
    div:nth-child(3) {
      margin-bottom: 34px;
      span:nth-child(1) {
        width: 60px;
        height: 4px;
        background: #ffffff;
        margin-right: 30px;
        display: inline-block;
        // border: 1px solid red;
      }
      span:nth-child(2) {
        font-size: 24px;
        font-family: "Microsoft YaHei";
        // font-family: HarmonyOS Sans-Black, HarmonyOS Sans;
        font-weight: 900;
        color: #ffffff;
        line-height: 34px;
      }
    }
    div:nth-child(4) {
      position: relative;
      p {
        width: 1211px;
        font-size: 60px;
        font-family: "Microsoft YaHei";
        //font-family: HarmonyOS Sans-Black, HarmonyOS Sans;
        font-weight: 900;
        color: #ffffff;
        line-height: 84px;
        word-spacing: -4px;
        span:nth-child(1) {
          color: #cf61dc;
          //border: 1px solid red;
        }
      }
      img {
        width: 53px;
        height: 86px;
        position: absolute;
        top: 40px;
        right: 17px;
      }
    }
    div:nth-child(5) {
      ul {
        margin-top: 40px;
        display: flex;
        li {
          flex: 1;
          position: relative;
          .Run:hover {
            background: #ffffff;
            p:nth-child(1) {
              color: #141414;
            }
            p:nth-child(2) {
              color: rgba(20, 20, 20, 0.800000011920929);
            }
          }
          .Run {
            // width: 645px;
            height: 189px;
            opacity: 1;
            border: 2px solid #ffffff;
            padding: 24px 24px;
            p:nth-child(1) {
              font-size: 22px;
              font-family: "Microsoft YaHei";
              //font-family: HarmonyOS Sans-Bold, HarmonyOS Sans;
              font-weight: bold;
              color: #ffffff;
              line-height: 31px;
              margin-bottom: 20px;
            }
            p:nth-child(2) {
              font-size: 18px;
              font-family: "Microsoft YaHei";
              // font-family: HarmonyOS Sans-Medium, HarmonyOS Sans;
              font-weight: 500;
              color: rgba(255, 255, 255, 0.800000011920929);
              line-height: 24px;
              margin-bottom: 24px;
            }
          }
        }
        li:nth-child(1) {
          margin-right: 15px;
          .Run:nth-child(1) {
            margin-bottom: 30px;
            .Img1 {
              width: 25px;
              height: 10px;
              position: absolute;
              bottom: 266px;
              right: 42px;
              background: url("../../../assets/pc/Home/Home6.png") no-repeat
                center;
              background-size: 100% !important;
            }
          }
          .Run:nth-child(1):hover {
            .Img1 {
              background: url("../../../assets/pc/Home/Home7.png") no-repeat
                center;
              background-size: 100% !important;
            }
          }
          .Run:nth-child(2) {
            padding: 24px 0;
            margin-bottom: 20px;
            p:nth-child(1) {
              margin-left: 24px;
              word-spacing: -2px;
            }
            p:nth-child(2) {
              margin-left: 24px;
            }
            .Img1 {
              width: 25px;
              height: 10px;
              position: absolute;
              bottom: 40px;
              right: 42px;
              background: url("../../../assets/pc/Home/Home6.png") no-repeat
                center;
              background-size: 100% !important;
            }
          }
          .Run:nth-child(2):hover {
            .Img1 {
              background: url("../../../assets/pc/Home/Home7.png") no-repeat
                center;
              background-size: 100% !important;
            }
          }
        }
        li:nth-child(2) {
          margin-left: 15px;
          .Run:nth-child(1) {
            margin-bottom: 30px;
            .Img2 {
              width: 25px;
              height: 10px;
              position: absolute;
              bottom: 266px;
              right: 42px;
              background: url("../../../assets/pc/Home/Home6.png") no-repeat
                center;
              background-size: 100% !important;
            }
          }
          .Run:nth-child(1):hover {
            .Img2 {
              background: url("../../../assets/pc/Home/Home7.png") no-repeat
                center;
              background-size: 100% !important;
            }
          }
          .Run:nth-child(2) {
            margin-bottom: 20px;
            .Img2 {
              width: 25px;
              height: 10px;
              position: absolute;
              bottom: 40px;
              right: 42px;
              background: url("../../../assets/pc/Home/Home6.png") no-repeat
                center;
              background-size: 100% !important;
            }
          }
          .Run:nth-child(2):hover {
            .Img2 {
              background: url("../../../assets/pc/Home/Home7.png") no-repeat
                center;
              background-size: 100% !important;
            }
          }
        }
      }
    }
    .qipao {
      width: 725px;
      height: 120px;
      background: #ffffff;
      border: 2px solid #000000;
      font-size: 18px;
      font-family: "Microsoft YaHei";
      //  font-family: HarmonyOS Sans-Bold, HarmonyOS Sans;
      font-weight: bold;
      color: #000000;
      line-height: 30px;
      padding: 15px 37px 15px 28px;
      position: absolute;
      top: -60px;
      right: 20px;
      z-index: 1;
    }
    .qipao2 {
      width: 725px;
      height: 120px;
      background: #ffffff;
      border: 2px solid #000000;
      position: absolute;
      top: -40px;
      right: 0px;
    }
  }
}
.homeBottom2 {
  width: 100%;
  background: #f4f4f4;
  .xianl {
    width: 1320px;
    background: #f4f4f4;
    margin: 0 auto;
    .xian {
      width: 30px;
      height: 30px;
      background: #141414;
      border-radius: 0px 0px 0px 0px;
      opacity: 1;
      margin-left: 1290px;
    }
  }

  .homeBottom-W {
    width: 1320px;
    margin: 0 auto;
    position: relative;
    padding-top: 120px;
    background: #f4f4f4;

    .Logo_Text {
      font-size: 60px;
      font-family: "Microsoft YaHei";
      //  font-family: HarmonyOS Sans-Black, HarmonyOS Sans;
      font-weight: 900;
      color: #141414;
      line-height: 84px;
      margin-bottom: 178px;
      text-align: center;
    }
    ul {
      // padding-bottom: 320px;
      padding-bottom: 220px;
      li {
        width: 954px;
        // height: 128px;
        height: 178px;
        // line-height: 178px;
        background: #ffffff;
        // border: 1px solid red;
        padding: 29px 48px;
        position: relative;
        margin: 81px 0;
        span {
          display: inline-block;
        }
        span:nth-child(2) {
          width: 158px;
          // height: 148px;
          height: 198px;
          background: #ea76f7;
          position: absolute;
          top: -10px;
          left: 262px;
          padding: 42px 45px;
          z-index: 10;
          img {
            width: 68px;
            height: 64px;
          }
        }
        .rightss {
          // border: 1px solid red;
          text-align: left;
          display: inline-block;
          width: 400px;
          padding-left: 60px;
          margin-top: -12px;
        }
        .rightss1 {
          // border: 1px solid red;
          text-align: left;
          display: inline-block;
          // margin-right: 38px;
          margin-top: -15px;
          // width: 600px;
        }
        span:nth-child(3) {
          p {
            font-size: 16px;
            font-family: "Microsoft YaHei";
            // font-family: HarmonyOS Sans-Black, HarmonyOS Sans;
            // font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
            font-weight: 400;
            // color: #141414;
            //color: red;
            line-height: 24px;
          }
        }
        .yinying {
          width: 634px;
          height: 45px;
          box-shadow: inset 13px 0px 20px 10px
            rgba(158, 59, 170, 0.4000000059604645);
          border-radius: 8px 8px 8px 8px;
          position: absolute;
          top: 200px;
          left: 155px;
          filter: blur(30px);
          -webkit-filter: blur(30px);
          // filter: progid:DXImageTransform.Microsoft.Blur(Pixel Radius=5,MakeShadow=false);
        }
        .JianT {
          position: absolute;
          top: 193px;
          left: 305px;
          z-index: 10;
          img {
            width: 74px;
            height: 40px;
          }
        }
      }
      li:nth-child(1) {
        margin-left: 303px;
        padding-right: 117px;
        span:nth-child(1) {
          font-size: 22px;
          font-family: "Microsoft YaHei";
          // font-family: HarmonyOS Sans-Black, HarmonyOS Sans;
          // font-family: HarmonyOS Sans SC-Bold, HarmonyOS Sans SC;
          font-weight: bold;
          color: #141414;
          line-height: 30px;
        }
        span:nth-child(3) {
          float: right;
        }
      }
      li:nth-child(2) {
        padding-right: 68px;
        margin-left: 34px;
        span:nth-child(1) {
          font-size: 16px !important;
          font-family: "Microsoft YaHei";
          //  font-family: HarmonyOS Sans-Black, HarmonyOS Sans !important;
          //font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC !important;
          font-weight: 400 !important;
          color: #141414 !important;
          line-height: 24px !important;
          margin-left: 8px;
          margin-top: 10px;
        }
        span:nth-child(2) {
          left: 531px !important;
        }
        span:nth-child(3) {
          float: right;
          p {
            font-size: 22px;
            font-family: "Microsoft YaHei";
            // font-family: HarmonyOS Sans-Black, HarmonyOS Sans;
            // font-family: HarmonyOS Sans SC-Bold, HarmonyOS Sans SC;
            font-weight: bold;
            color: #141414;
            line-height: 30px;
          }
        }

        .JianT {
          left: 575px;
        }
      }
      li:nth-child(3) {
        margin-left: 303px;
        // display: flex;
        // padding-right: 134px;
        // border: 1px solid red;
        span:nth-child(1) {
          font-size: 22px;
          font-family: "Microsoft YaHei";
          //  font-family: HarmonyOS Sans-Black, HarmonyOS Sans;
          // font-family: HarmonyOS Sans SC-Bold, HarmonyOS Sans SC;
          font-weight: bold;
          color: #141414;
          line-height: 30px;
        }
        span:nth-child(2) {
          margin-right: 100px;
        }
        span:nth-child(3) {
          margin-left: 400px;
          margin-top: -50px;
          // float: right;
          // padding-left: 100px;
          // margin-right: 205px;
          // border: 1px solid green;
        }
      }
      li:nth-child(4) {
        padding-right: 68px;
        margin-left: 34px;
        span:nth-child(1) {
          font-size: 16px !important;
          font-family: "Microsoft YaHei";
          //font-family: HarmonyOS Sans-Black, HarmonyOS Sans !important;
          //  font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC !important;
          font-weight: 400 !important;
          color: #141414 !important;
          line-height: 24px !important;
          margin-left: 35px;
          // border:1px solid red;
        }
        span:nth-child(2) {
          left: 531px !important;
        }
        span:nth-child(3) {
          float: right;
          p {
            font-size: 22px;
            font-family: "Microsoft YaHei";
            // font-family: HarmonyOS Sans-Black, HarmonyOS Sans;
            // font-family: HarmonyOS Sans SC-Bold, HarmonyOS Sans SC;
            font-weight: bold;
            color: #141414;
            line-height: 30px;
          }
        }
        .JianT {
          left: 575px;
        }
      }
      li:nth-child(5) {
        margin-left: 303px;
        padding-right: 39px;
        padding-top: 34px;
        padding-bottom: 34px;
        span:nth-child(1) {
          font-size: 22px;
          font-family: "Microsoft YaHei";
          // font-family: HarmonyOS Sans-Black, HarmonyOS Sans;
          // font-family: HarmonyOS Sans SC-Bold, HarmonyOS Sans SC;
          font-weight: bold;
          color: #141414;
          line-height: 58px;
        }
        span:nth-child(3) {
          float: right;
          p:nth-child(1) {
            margin-bottom: 12px;
          }
        }
      }
      li:nth-child(6) {
        padding-right: 68px;
        margin-left: 34px;
        span:nth-child(1) {
          font-size: 16px !important;
          font-family: "Microsoft YaHei";
          // font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC !important;
          // font-family: HarmonyOS Sans-Black, HarmonyOS Sans !important;
          font-weight: 400 !important;
          color: #141414 !important;
          line-height: 24px !important;
          margin-left: 67px;
        }
        span:nth-child(2) {
          left: 531px !important;
        }
        span:nth-child(3) {
          float: right;
          p {
            font-size: 22px;
            font-family: "Microsoft YaHei";
            // font-family: HarmonyOS Sans SC-Bold, HarmonyOS Sans SC;
            // font-family: HarmonyOS Sans-Black, HarmonyOS Sans;
            font-weight: bold;
            color: #141414;
            line-height: 30px;
          }
        }
        .JianT {
          left: 575px;
        }
      }
      li:nth-child(7) {
        margin-left: 303px;
        padding-right: 134px;
        span:nth-child(1) {
          font-size: 22px;
          font-family: "Microsoft YaHei";
          // font-family: HarmonyOS Sans SC-Bold, HarmonyOS Sans SC;
          //font-family: HarmonyOS Sans-Black, HarmonyOS Sans;
          font-weight: bold;
          color: #141414;
          line-height: 30px;
        }
        span:nth-child(3) {
          float: right;
          margin-right: 116px;
        }
      }
      li:nth-child(8) {
        padding-right: 68px;
        margin-left: 34px;
        span:nth-child(1) {
          font-size: 16px !important;
          font-family: "Microsoft YaHei";
          //font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC !important;
          //font-family: HarmonyOS Sans-Black, HarmonyOS Sans !important;
          font-weight: 400 !important;
          color: #141414 !important;
          line-height: 24px !important;
          margin-left: 60px;
        }
        span:nth-child(2) {
          left: 531px !important;
        }
        span:nth-child(3) {
          float: right;
          p {
            font-size: 22px;
            font-family: "Microsoft YaHei";
            // font-family: HarmonyOS Sans SC-Bold, HarmonyOS Sans SC;
            // font-family: HarmonyOS Sans-Black, HarmonyOS Sans;
            font-weight: bold;
            color: #141414;
            line-height: 30px;
          }
        }
        .JianT {
          left: 575px;
        }
      }
      li:nth-child(9) {
        margin-left: 303px;
        padding-right: 134px;
        span:nth-child(1) {
          font-size: 22px;
          font-family: "Microsoft YaHei";
          //font-family: HarmonyOS Sans SC-Bold, HarmonyOS Sans SC;
          //   font-family: HarmonyOS Sans-Black, HarmonyOS Sans;
          font-weight: bold;
          color: #141414;
          line-height: 30px;
        }
        span:nth-child(3) {
          float: right;
          margin-right: 72px;
        }
        .JianT {
          img {
            display: none;
          }
        }
      }
    }
    .swiper-slide_all {
      width: 100%;
      height: 1074px;
      background: #ffffff;
      padding: 260px 0 144px 336px;
      .Swiper-Text {
        p:nth-child(1) {
          font-size: 40px;
          //font-family: HarmonyOS Sans-Bold, HarmonyOS Sans;
          // font-family: HarmonyOS Sans-Black, HarmonyOS Sans;
          font-family: "Microsoft YaHei";
          font-weight: bold;
          color: #141414;
          line-height: 56px;
          margin-bottom: 60px;
          padding-left: 36px;
        }
        p:nth-child(2) {
          font-size: 22px;
          // font-family: HarmonyOS Sans-Medium, HarmonyOS Sans;
          // font-family: HarmonyOS Sans-Black, HarmonyOS Sans;
          font-family: "Microsoft YaHei";
          font-weight: 500;
          line-height: 31px;
          color: rgba(20, 20, 20, 0.800000011920929);
          padding-left: 36px;
        }
      }
    }
    .SwiperBac {
      background: #cf61dc;
    }
    .homeBottom_Btn_all {
      width: 100%;
      position: absolute;
      bottom: 276px;
      .homeBottom_Btn {
        position: relative;
        width: 1320px;
        height: 64px;
        margin: 0 auto;

        button {
          width: 64px;
          height: 64px;
          opacity: 1;
          border: 2px solid #141414;
          border-radius: 50%;
          img {
            width: 25px;
            height: 30px;
          }
        }
        .swiper-button-prev:after,
        .swiper-button-next:after {
          content: "";
        }
      }
      .ShijainZ {
        width: 80%;
        height: 1px;
        border: 4px solid #141414;
        position: absolute;
        bottom: -86px;
        right: 85px;
        z-index: 100;
        border-radius: 5px;
      }
    }
  }
}
.homeBottomChart {
  width: 100%;
  background: #f4f4f4;
  // height: 1028px;
  // border: 1px solid red;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  .homeBottom-W {
    background: #f4f4f4;
    width: 1320px;
    margin: 0 auto;
    //  position: relative;
    .Infortitle {
      padding-top: 125px;
      .Infort1 {
        height: 70px;
        font-size: 60px;
        font-family: "Microsoft YaHei";
        // font-family: HarmonyOS Sans-Black, HarmonyOS Sans;
        font-weight: 900;
        color: #141414;
        line-height: 70px;
        // -webkit-background-clip: text;
        // -webkit-text-fill-color: transparent;
      }
      .Infort2 {
        width: 1315px;
        margin-top: 32px;
        height: 96px;
        font-size: 32px;
        font-family: "Microsoft YaHei";
        // font-family: HarmonyOS Sans-Black, HarmonyOS Sans;
        font-weight: 900;
        color: #141414;
        line-height: 48px;
        span {
          color: #cf61dc;
        }
      }
    }
    .Inforcont {
      margin-top: 64px;
      position: relative;
      // display: flex;
      .contents {
        position: absolute;
        z-index: 99999;
        .cons1 {
          width: 673px;
          // height: 192px;
          font-size: 18px;
          font-family: "Microsoft YaHei";
          // font-family: HarmonyOS Sans-Medium, HarmonyOS Sans;
          font-weight: 500;
          color: #141414;
          line-height: 32px;
          // -webkit-background-clip: text;
          // -webkit-text-fill-color: transparent;
        }
        .cons2 {
          width: 673px;
          // height: 192px;
          font-size: 18px;
          font-family: "Microsoft YaHei";
          // font-family: HarmonyOS Sans-Medium, HarmonyOS Sans;
          font-weight: 500;
          color: #141414;
          line-height: 32px;
        }
        .cons3 {
          width: 673px;
          // height: 192px;
          font-size: 18px;
          font-family: "Microsoft YaHei";
          //  font-family: HarmonyOS Sans-Medium, HarmonyOS Sans;
          font-weight: 500;
          color: #141414;
          line-height: 32px;
          span {
            color: #cf61dc;
            cursor: pointer;
          }
        }
        .cons4 {
          margin-top: 18px;
          width: 673px;
          height: 32px;
          font-size: 18px;
          font-family: "Microsoft YaHei";
          // font-family: HarmonyOS Sans-Medium, HarmonyOS Sans;
          font-weight: 500;
          color: #141414;
          line-height: 32px;
        }
        .cons5 {
          margin-top: 17px;
          width: 673px;
          height: 67px;
          font-size: 14px;
          font-family: "Microsoft YaHei";
          // font-family: HarmonyOS Sans-Medium, HarmonyOS Sans;
          font-weight: 500;
          color: #666666;
          line-height: 22px;
        }
      }
      .charts {
        width: 1320px;
        height: 660px;
        // border: 1px solid red;
      }
      .To_List {
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.8);
        position: fixed;
        top: 0;
        left: 0;
        z-index: 999999999;
        overflow: hidden;
        overscroll-behavior: contain;
        // overflow: scroll;
        // -webkit-overflow-scrolling: touch;
        .To_List-all {
          // position: absolute;
          top: 15%;
          left: 40%;
          position: fixed;
          margin-left: 72px;
          // width: 364px;
          width: 480px;
          background: #f4f4f4;
          padding: 20px 20px;
          border-radius: 16px;

          .To_List_top {
            height: 42px;
            width: 480px;
            display: flex;
            justify-content: space-between;

            opacity: 1;
            // padding: 20px 20px 0 20px;
            span:nth-child(1) {
              height: 20px;
              font-size: 20px;
              font-family: "Microsoft YaHei";
              //  font-family: HarmonyOS Sans-Bold, HarmonyOS Sans;
              font-weight: 700;
              color: #141414;
              line-height: 42px;
            }
            span:nth-child(2) {
              cursor: pointer;

              margin-right: 30px;
              display: block;
              img {
                width: 32px;
                height: 32px;
              }
            }
          }
          .To_List_ul {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            margin-top: 40px;
            // margin-left: 10px;
            // border: 1px solid red;
            .To_listt {
              width: 440px;
              margin: 0 auto;
              height: 40px;
              background: #ededed;
              border-radius: 4px 4px 4px 4px;
              opacity: 1;
              display: flex;
              justify-content: space-between;
              .To_listtit {
                font-size: 14px;
                font-family: "Microsoft YaHei";
                // font-family: HarmonyOS Sans-Medium, HarmonyOS Sans;
                font-weight: 500;
                color: #666666;
                height: 40px;
                line-height: 40px;
                margin-left: 16px;
              }
              .To_listtcon {
                font-size: 14px;
                font-family: "Microsoft YaHei";
                //  font-family: HarmonyOS Sans-Medium, HarmonyOS Sans;
                font-weight: 500;
                color: #666666;
                height: 40px;
                line-height: 40px;
                margin-right: 16px;
              }
            }
            ul {
              // height: 610px;
              overflow: hidden;

              // overflow: scroll;
              // -webkit-overflow-scrolling: touch;

              li {
                display: flex;
                justify-content: space-between;
                height: 36px;
                line-height: 36px;
                margin-left: 16px;
                margin-right: 16px;
                margin-top: 17px;

                // border: 1px solid red;
              }
            }
            ::-webkit-scrollbar {
              // overflow: hidden !important;
              /*滚动条整体样式*/
              width: 0px; /*高宽分别对应横竖滚动条的尺寸*/
              height: 1px;
            }
            /*滚动条里面小方块*/
            ::-webkit-scrollbar-thumb {
              opacity: 0;
              //  overflow: hidden !important;
            }
          }
        }
      }
    }
  }
}
.Ambassador {
  width: 100%;
  // border: 1px solid red;
  height: 540px;
  background: #f4f4f4;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  .Ambassador_w {
    width: 1320px;
    background: #f4f4f4;
    margin: 0 auto;
    .Amba_tit {
      margin-top: 230px;
      display: flex;
      .line {
        width: 60px;
        height: 4px;
        background: #141414;
        border-radius: 0px 0px 0px 0px;
        opacity: 1;
        margin-top: 12px;
        margin-right: 30px;
      }
      .line_tit {
        font-size: 24px;
        font-family: HarmonyOS Sans-Black, HarmonyOS Sans;
        font-weight: 900;
        color: #141414;
      }
    }
    .Amba_con {
      margin-top: 35px;
      height: 70px;
      font-size: 60px;
      font-family: HarmonyOS Sans-Black, HarmonyOS Sans;
      font-weight: 900;
      color: #141414;
      line-height: 70px;
      span {
        color: #cf61dc;
      }
    }
    .Amba_foot {
      margin-top: 60px;
      display: flex;
      .Amba_footl {
        width: 910px;
        height: 96px;
        font-size: 22px;
        font-family: HarmonyOS Sans-Medium, HarmonyOS Sans;
        font-weight: 500;
        color: #141414;
        line-height: 48px;
      }
      .Amba_footr {
        width: 179px;
        height: 51px;
        line-height: 51px;
        background: #141414;
        border-radius: 25px 25px 25px 25px;
        opacity: 1;
        margin-left: 231px;
        margin-top: 22px;
        text-align: center;
        font-size: 20px;
        font-family: HarmonyOS Sans SC-Bold, HarmonyOS Sans SC;
        font-weight: 700;
        color: #f4f4f4;
        cursor: pointer;
      }
    }
  }
}
.homeBottomNft {
  width: 100%;
  // border: 1px solid red;
  background: #141414;
  // height: 761px;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  .homeBottom-W {
    width: 1320px;
    background: #141414;
    margin: 0 auto;
    //  position: relative;
    .homeNfttile {
      // margin-top: 114px;
      display: flex;
      justify-content: space-between;
      .homeNl {
        margin-top: 114px;
        width: 943px;
        height: 126px;
        border-radius: 0px 0px 0px 0px;
        opacity: 1;
        // border: 1px solid red;
        .homeNlt {
          display: flex;
          span {
            width: 60px;
            height: 4px;
            background: #ffffff;
            margin-right: 30px;
            display: inline-block;
            margin-top: 14px;
          }
          div {
            height: 28px;
            font-size: 24px;
            font-family: "Microsoft YaHei";
            // font-family: HarmonyOS Sans-Black, HarmonyOS Sans;
            font-weight: 900;
            color: #ffffff;
            line-height: 28px;
          }
        }
        .homeNlc {
          margin-top: 38px;
          width: 1000px;
          height: 60px;
          font-size: 58px;
          font-family: "Microsoft YaHei";
          //  font-family: HarmonyOS Sans-Black, HarmonyOS Sans;
          font-weight: 900;
          color: #f4f4f4;
          line-height: 60px;
          span {
            color: #ea76f7;
          }
        }
      }
      .homeNr {
        margin-top: 114px;
        img {
          width: 55px;
          height: 88px;
        }
      }
    }
    .homeNftcont {
      margin-top: 64px;
      ul {
        display: flex;
        z-index: 99999999;
        li {
          width: 179px;
          height: 311px;
          // border-radius: 56px 56px 56px 56px;
          opacity: 1;
          margin-right: 11px;
          //  border: 1px solid red;
          margin-bottom: 147px;
          img {
            width: 179px;
            height: 179px;
            // border-radius: 5px 5px 5px 5px;
          }
          img:hover {
            transform: scale(1.1);
          }
          span {
            height: 20px;
            font-size: 16px;
            font-family: "Microsoft YaHei";
            // font-family: HarmonyOS Sans-Bold, HarmonyOS Sans;
            font-weight: 700;
            color: #ffffff;
            line-height: 20px;
            width: 179px;
            text-align: center;
            display: inline-block;
          }
          span:nth-child(2) {
            font-size: 16px;
            font-family: "Microsoft YaHei";
            //  font-family: HarmonyOS Sans-Bold, HarmonyOS Sans;
            font-weight: 700;
            color: #ffffff;
            margin-top: 40px;
            font-weight: 1000;
          }
          span:nth-child(3) {
            opacity: 0.8;
            font-size: 14px;
            font-family: "Microsoft YaHei";
            //  font-family: HarmonyOS Sans-Regular, HarmonyOS Sans;
            font-weight: 400;
            color: rgba(255, 255, 255, 0.8);
            margin-top: 20px !important;
          }
        }
      }
      .xiana {
        width: 30px;
        height: 68px;
        background: #ffffff;
        border-radius: 0px 0px 0px 0px;
        opacity: 1;
        margin-left: 1290px;
        // border: 1px solid red;
        // margin-top: 74px;
        // float: right;
      }
    }
  }
}
</style>
